import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Titles from "../../components/Titles";
import Picture from "../../components/Picture";
import Pictures from "../../components/Locals";
import { openInNewTab } from "../../components/Header";

interface IEnterence {}

const EnterenceDiv = styled.div`
  height: 800px;
  width: 100%;
  background-color: #0b152f;
  animation: mymove;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      display: flex;
      flex-direction: row;
      img {
        border-radius: 20px 0px 20px 0px;
        height: auto;
        height: 25rem;
        width: auto;
        -webkit-transition: 0.15s;
        -moz-transition: 0.15s;
        -ms-transition: 0.15s;
        -o-transition: 0.15s;
        transition: 0.15s;
        animation: ease 0.15s;

        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        animation-direction: alternate;
      }
      img:hover {
        border-radius: 20px 20px 20px 20px;
        transform: scale(1.1);
        -webkit-transition: 0.15s;
        -moz-transition: 0.15s;
        -ms-transition: 0.15s;
        -o-transition: 0.15s;
        transition: 0.15s;
        animation: ease 0.15s;
      }

      div {
        display: flex;
        flex-direction: column;
        height: 100%;

        .Title {
        }

        span {
          height: 100%;
          width: 90%;
          color: white;
          font-size: 14px;
          letter-spacing: 0.05rem;
          font-family: "RocknRoll One";
          line-height: 2;
          text-align: left;
        }
      }
    }
    @media screen and (max-width: 1200px) {
      div {
        flex-direction: column;
        width: 100%;

        div {
          span {
            width: 100%;
          }
        }
      }
    }

    @media screen and (max-width: 500px) {
      div {
        flex-direction: column;
        width: 100%;
        img {
          height: 250px;
          width: 250px;
        }
        div {
          span {
            text-align: center;
            width: 100%;
          }
        }
      }
    }

    @media screen and (max-width: 400px) {
      div {
        img {
          height: 200px;
          width: 200px;
        }
    }
  }
`;

const calculateTimeLeft = () => {
  let year = new Date().getFullYear();
  let difference = +new Date(`10/01/${year}`) - +new Date();

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};

const EnterenceContainer: React.FC<IEnterence> = (props) => {
  let enterenceRef = useRef<HTMLDivElement>(null);
  let entereceTitle = useRef<HTMLDivElement>(null);
  // const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setTimeLeft(calculateTimeLeft());
  //   }, 1000);
  // });

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(enterenceRef.current!, {
      opacity: 0.9,
      scale: 0.9,
      duration: 1,
      y: 300,
      scrollTrigger: {
        trigger: enterenceRef.current!,
        toggleActions: "play none none reverse",
      },
    });
    gsap.from(entereceTitle.current!, {
      opacity: 0.9,
      scale: 0.9,
      duration: 3,
      y: -300,
      scrollTrigger: {
        trigger: entereceTitle.current!,
        toggleActions: "play none none reverse",
      },
    });
  });

  return (
    <EnterenceDiv ref={enterenceRef}>
      <div>
        <div ref={entereceTitle}>
          <img src={Pictures["emoji"].default} />
          <div style={{ cursor: "pointer"}}>
            <div 
            onClick={() => openInNewTab("http://www.rocknbones.com/mint")}
            style={{ borderRadius: "2rem", marginTop: "1rem", marginBottom: "1rem"}}
            >
              <Titles
                {...{
                  data: {
                    title: "CLICK TO MINT!",
                    subtitle: "",
                    textAlign: "left",
                  },
                  color: "#f0cb39",
                  colorSub: "",
                }}
              />
            </div>

            <span>
              🎺"Rock n Bones purchases and fractionalizes Blue Chip NFT to be
              distributed to its members. The rhythm token represents fractional
              shares of Blue Chip NFT held in the Vault. Each Rock n Bones NFT
              10 tokens per day for 10 years after being Minted. In addition,
              each Rock n Bones NFT grants access to the exclusive DOA community
              as well as voting rights over DOA’s Assets.🎸The Rock n Bones DOA
              will provide holders with exclusive exclusive access to NFT drops,
              periodically claimable NFTs, and more"🎻
            </span>
          </div>
        </div>
      </div>
    </EnterenceDiv>
  );
};

export default EnterenceContainer;
